"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var useColumns_1 = require("../../../../hooks/useColumns");
var useRenderCellViews_1 = require("../../../../hooks/useRenderCellViews");
var PimBulkEditPreview = function (_a) {
    var bulkEditPayload = _a.bulkEditPayload, setBulkEditPayload = _a.setBulkEditPayload;
    var categories = (0, react_redux_1.useSelector)(function (state) { return state.categoryState; }).categories;
    var products = (0, react_redux_1.useSelector)(function (state) { return state.productState; }).products;
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.productAttributeState; }), productAttributes = _b.productAttributes, pagination = _b.pagination, loading = _b.loading;
    var renderCellViews = (0, useRenderCellViews_1.useRenderCellViews)().renderCellViews;
    var columns = (0, useColumns_1.useColumns)().columns;
    var renderCellView = function (column, cellView) {
        return (0, jsx_runtime_1.jsx)("div", { children: cellView === null || cellView === void 0 ? void 0 : cellView.content }, column.uid);
    };
    var handleRemoveRecord = function (id) {
        var updatedPayload = bulkEditPayload.filter(function (record) { return record.uid !== id; });
        setBulkEditPayload(updatedPayload);
    };
    var modifiedColumns = __spreadArray(__spreadArray(__spreadArray([], columns, true), [
        { name: "Category", uid: "category_id", sortable: true },
        { name: "Attributes", uid: "attributes", sortable: true }
    ], false), productAttributes.map(function (attr) { return ({ name: attr.name, uid: attr.name, sortable: true }); }), true);
    var modifiedBulkEditPayload = bulkEditPayload.map(function (item) { var _a; return (__assign(__assign({}, item), { title: ((_a = products.find(function (p) { return p._id === item._id; })) === null || _a === void 0 ? void 0 : _a.title) || "" })); });
    var filteredColumns = modifiedColumns.filter(function (column) { return bulkEditPayload.some(function (record) { return column.uid in record; }); });
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "p-4 grid grid-cols-1 gap-4 w-[400px]" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "grid grid-cols-".concat(filteredColumns.length + 1, " gap-4 items-center") }, { children: filteredColumns.map(function (column) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "font-medium" }, { children: column.name }), column.uid)); }) })), modifiedBulkEditPayload.length > 0 ? (modifiedBulkEditPayload.map(function (record) { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "flex-row grid grid-cols-".concat(filteredColumns.length + 1, " gap-4 items-center w-full") }, { children: filteredColumns.map(function (column) {
                            var cellView = renderCellViews(record[column.uid], record).find(function (cValue) { return column.uid === (cValue === null || cValue === void 0 ? void 0 : cValue.key); });
                            return renderCellView(column, cellView);
                        }) }), record.uid), (0, jsx_runtime_1.jsx)("hr", { className: "my-2 border-gray-300" })] })); })) : ((0, jsx_runtime_1.jsx)("div", __assign({ className: "text-center text-gray-500" }, { children: "No records to display" })))] })));
};
exports.default = PimBulkEditPreview;
